// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3KCWB","head":"ProcedureTableInfo_head__1Oens"};